import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getRandomString(bytes: number) {
  const randomValues = new Uint8Array(bytes);
  window.crypto.getRandomValues(randomValues);
  return Array.from(randomValues).map(intToHex).join("");
}

function intToHex(nr: number) {
  return nr.toString(16).padStart(2, "0");
}

export function isBrowser() {
  return typeof window !== "undefined";
}

/**
 * Algorithm to sort programs by estimated savings per month, to be used with Array.sort()
 * @param a program a
 * @param b program b
 * @returns 1 if a is eligible and b is not, -1 if b is eligible and a is not, or the difference in estimated savings per month
 */
export function sortProgramsBySavings(
  a: {
    eligibility: boolean | null;
    estimatedSavingsPerMonth: number | null;
  } & Record<string, unknown>,
  b: {
    eligibility: boolean | null;
    estimatedSavingsPerMonth: number | null;
  } & Record<string, unknown>,
) {
  if (a.eligibility && a.estimatedSavingsPerMonth && !b.eligibility) {
    return -1;
  }
  if (!a.eligibility && b.eligibility && b.estimatedSavingsPerMonth) {
    return 1;
  } else {
    return b.estimatedSavingsPerMonth! - a.estimatedSavingsPerMonth!;
  }
}

/**
 * It receives the number and return it as a dollar value.
 * @param nr number that will be returned as money
 * @param isFloat if it should display decimals, default is false
 * @returns string prefixed with $ symbol and formatting money
 */
export function numberToMoney(nr: number, isFloat: boolean = false): string {
  if (isFloat) {
    return `$${nr.toFixed(2)}`;
  } else {
    return `$${Math.floor(nr)}`;
  }
}

/**
 * Function to calculate the estimated total savings
 * @param data programs data
 * @returns total savings
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function calculateTotalSavings(data: any[]) {
  let totalSavings = 0;

  for (const item of data) {
    if (item.program.eligibility) {
      totalSavings += Math.abs(item.program.estimatedSavingsPerMonth);
    }
  }

  return totalSavings;
}

export const maskPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return "";
  }

  const lastFourDigits = phoneNumber.slice(-4);

  return "(***) ***-" + lastFourDigits;
};

export const returnLocale = (locale: string): string => {
  switch (locale) {
    case "en":
      return "en";
    case "es":
      return "es";
    default:
      return "en";
  }
};
